<rask-fieldset-toggle
  [formGroup]="form"
  label="Produktionsomrade"
  [defaultExpanded]="open"
  [nrOfSelectedFilters]="filterLength">
  @if (marknadsomraden) {
    <rask-tree-selector
      class="w-100"
      label="Produktionsomrade"
      (change)="selectionChanged()"
      [items]="marknadsomraden">
    </rask-tree-selector>
  }
</rask-fieldset-toggle>